import 'is-in-viewport'
import {smoothScroll} from './navigation'

const animateInViewportClasses = [
  'move-up-in-viewport',
  'move-down-in-viewport',
  'move-left-in-viewport',
  'move-right-in-viewport',
  'fade-in-in-viewport',
  'zoom-in-in-viewport',
  'active-in-viewport',
  'full-width-in-viewport',
  'animate-in-in-viewport',
  'slide-in-in-viewport',
]

let didScroll = false
let scrollTimeout

$(function () {
  animateInViewport(200)
  // updateStyle()

  goToHref(location.href)

  $('a')
    .filter(function () {
      const href = $(this).attr('href')
      return (
        href &&
        !href.startsWith('#') &&
        $(this).attr('target') !== '_blank' &&
        href.startsWith(window.location.origin)
      )
    })
    .on('click', function (event) {
      event.preventDefault()
      goToHref($(this).attr('href'))
    })
})

export function goToHref(href) {
  if (!href || typeof href !== 'string') return
  $('html').addClass('fade-out')

  const splitHref = href.split('#')
  if (splitHref.length > 0) {
    const scrollToElement = document.querySelector('#' + splitHref[1])
    if (scrollToElement) {
      const scrollElementRect = scrollToElement.getBoundingClientRect()
      const offset = scrollElementRect.top < 0 ? $('.site-header').outerHeight() : 0
      smoothScroll.animateScroll(scrollToElement, null, {offset})
      return
    }
  }
  setTimeout(() => {
    if (window.location.href !== href) {
      window.location.href = href
    }
  }, 1)
}

export function onScroll() {
  if (!scrollTimeout) {
    scrollTimeout = setTimeout(function () {
      animateInViewport()
      didScroll = true
      scrollTimeout = null // Reset timeout
      // updateStyle()
    }, 100) // Delay in milliseconds
  }
}

$(window).scroll(onScroll)
export function animateInViewport(timeout) {
  $(animateInViewportClasses.map((cls) => `.${cls}`).join(','))
    .filter(':not(.wait-to-animate)')
    .each(function () {
      const $this = $(this)

      if ($this.is(':in-viewport')) {
        if (timeout > 0) {
          setTimeout(() => $this.addClass('active'), timeout)
        } else {
          $this.addClass('active')
        }
      }
    })
}
